import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export const trackProductClick = ({
  searchTerm,
  searchMethod,
  resultsFilters,
  location,
  currency,
  clickedProduct,
  itemListName,
  itemListSlot,
  itemListServiceConfig,
}: {
  searchTerm?: string;
  searchMethod?: string;
  resultsFilters?: {
    category?: string;
    price?: {
      min?: string;
      max?: string;
    };
  };
  location: string;
  currency: string;
  clickedProduct: Array<EcommerceCartItem> | EcommerceCartItem | undefined;
  itemListName?: string;
  itemListSlot?: string;
  itemListServiceConfig?: string;
}) => {
  const normalizedItems = Array.isArray(clickedProduct) ? clickedProduct : clickedProduct ? [clickedProduct] : [];

  const items = normalizedItems.map(item => ({
    ...item,
    ...(itemListName && { item_list_name: itemListName }),
    ...(itemListSlot && { item_list_slot: itemListSlot }),
    ...(itemListServiceConfig && { item_list_service_config: itemListServiceConfig }),
  }));

  const payload = {
    event: 'select_item',
    searchTerm,
    searchMethod,
    filters: resultsFilters,
    location,
    item_list_name: itemListName || undefined,
    item_list_slot: itemListSlot || undefined,
    item_list_service_config: itemListServiceConfig || undefined,
    ecommerce: {
      currency,
      items,
    },
  };

  pushToDataLayer(payload);
};
